/**
 * WeChat Modal Window.
 * @format
 */
/* eslint-disable max-len */

import React, { useState } from 'react';
import ModalWrapper from '@components/modals/modal-wrapper';

/**
 * Wechat.
 */
const WeChatModal = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  /**
   * Toggle WeChat Window.
   */
  const toggleWeChatWindow = (
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    event.preventDefault();
    setShowModal(!showModal);
  };

  /**
   * Render.
   */
  return (
    <>
      <a
        href="https://www.wechat.com/en"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => toggleWeChatWindow(e)}>
        <i className="fab fa-weixin" />
        <span className="visually-hidden">WeChat</span>
      </a>
      <ModalWrapper showModal={showModal} setShowModal={setShowModal}>
        <h2 className="font-size-xl">微信公众号</h2>
        <div className="grid-3-columns">
          <div className="grid-item">
            <img
              alt="瓦里安医疗 QR Code"
              src="/themes/custom/varian/images/qr-varian-china.png"
              className="img-responsive"
            />
            <p>瓦里安医疗</p>
          </div>
          <div className="grid-item">
            <img
              alt="放疗界 QR Code"
              src="/themes/custom/varian/images/qr-fangliaojie.png"
              className="img-responsive"
            />
            <p>放疗界</p>
          </div>
          <div className="grid-item">
            <img
              alt="瓦里安客户服务 QR Code"
              src="/themes/custom/varian/images/qr-customer-support.png"
              className="img-responsive"
            />
            <p>瓦里安客户服务</p>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export default WeChatModal;
